import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-stone-50">
        <div className="text-stone-500 font-body text-sm">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    // FASE 18.4 — preserve destination (calendar deep links, shared URLs)
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // Fase F — kiosk profile is locked to the punch-only screen
  if (user.role === "timeclock_kiosk" && location.pathname !== "/kiosk") {
    return <Navigate to="/kiosk" replace />;
  }

  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
